// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".job-notes[data-v-3a6f105d]{background-color:hsla(0,0%,80%,.14);padding:5px;font-size:11px;line-height:10px;word-break:break-all}.job-notes[data-v-3a6f105d],.lastSent[data-v-3a6f105d]{border-radius:3px;font-family:monospace;display:inline-block}.lastSent[data-v-3a6f105d]{width:82px;font-size:10px;line-height:11px;font-weight:100;white-space:normal;overflow:hidden;margin-top:5px;background-color:hsla(0,0%,80%,.23);padding:2px 5px 2px 5px;vertical-align:middle}", ""]);
// Exports
module.exports = exports;
